import React from 'react';
import { get } from 'lodash';
import historykana from 'historykana';

import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import * as textUtil from '../../../../../../utils/textUtil.js';

export class FullNameForm extends BasicForm {
  history = {
    firstName: [],
    lastName: [],
  };

  compositionHasNotStarted = true

  componentDidMount () {
    this.checkValuesToTouch();
  }

  checkValuesToTouch () {
    const { touch, nameMap } = this.props;

    if (this.inputMap.lastName.input.value) {
      touch(nameMap.lastName);
    }
    if (this.inputMap.firstName.input.value) {
      touch(nameMap.firstName);
    }

    if (this.isWithPhonetic) {
      if (this.inputMap.lastNamePhonetic.input.value) {
        touch(nameMap.lastNamePhonetic);
      }
      if (this.inputMap.firstNamePhonetic.input.value) {
        touch(nameMap.firstNamePhonetic);
      }
    }
  }

  getFurigana (history) {
    return textUtil.hiraganaToKatakana(historykana(history))
  }

  handleLastNameChange = (e) => {
    this.inputMap.lastName.input.onChange(e);

    if (this.isWithPhonetic) {
      if (this.compositionHasNotStarted) {
        this.history.lastName.push(e.target.value);
      }
      this.updateNamePhonetic('lastName');
    }
  }

  updateNamePhonetic(type) {
    let value = null;
    switch (type) {
      case 'firstName':
        value = this.getFurigana(this.history.firstName);
        this.inputMap.firstNamePhonetic.input.onChange(value);
        break;
      case 'lastName':
        value = this.getFurigana(this.history.lastName);
        this.inputMap.lastNamePhonetic.input.onChange(value);
        break;
    }
  }

  handleNameCompositionStart = () => {
    this.compositionHasNotStarted = false;
  }

  handleLastNameCompositionUpdate = (e) => {
    if (!this.compositionHasNotStarted) {
      this.history.lastName.push(e.data)
    }
  }

  handleLastNameCompositionEnd = (e) => {
    this.compositionHasNotStarted = true;
    if (e.data === '') {
      this.history.lastName.push(e.data);
      this.updateNamePhonetic('lastName');
    }
  }

  handleFirstNameChange = (e) => {
    this.inputMap.firstName.input.onChange(e);

    if (this.isWithPhonetic) {
      if (this.compositionHasNotStarted) {
        this.history.firstName.push(e.target.value);
      }
      this.updateNamePhonetic('firstName');
    }
  }

  handleFirstNameCompositionUpdate = (e) => {
    if (!this.compositionHasNotStarted) {
      this.history.firstName.push(e.data)
    }
  }

  handleFirstNameCompositionEnd = (e) => {
    this.compositionHasNotStarted = true;
    if (e.data === '') {
      this.history.firstName.push(e.data);
      this.updateNamePhonetic('firstName');
    }
  }

  render () {
    const {
      object,
      disabled,
    } = this.props;

    const error = this.error;
    const touched = this.touched;
    const valid = this.valid;

    const inputProps = {
      disabled,
      className: 'cu-ui-input',
      type: 'text',
    };

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={valid}
          label={object.label}
          required={object.validations.required}
        />
        <div className="cu-ui-full-name">
          <input
            { ...inputProps }
            { ...this.inputMap.lastName.input }
            data-testid="FullNameForm_lastNameInput"
            placeholder={get(object, 'data.last_name.placeholder', '')}
            onChange={this.handleLastNameChange}
            onFocus={this.handleFocusInput(this.inputMap.lastName.input.onFocus)}
            onBlur={this.handleBlurInput(this.inputMap.lastName.input.onBlur)}
            onCompositionStart={this.handleNameCompositionStart}
            onCompositionUpdate={this.handleLastNameCompositionUpdate}
            onCompositionEnd={this.handleLastNameCompositionEnd}
          />
          <input
            { ...inputProps }
            { ...this.inputMap.firstName.input }
            data-testid="FullNameForm_firstNameInput"
            placeholder={get(object, 'data.first_name.placeholder', '')}
            onChange={this.handleFirstNameChange}
            onFocus={this.handleFocusInput(this.inputMap.firstName.input.onFocus)}
            onBlur={this.handleBlurInput(this.inputMap.firstName.input.onBlur)}
            onCompositionStart={this.handleNameCompositionStart}
            onCompositionUpdate={this.handleFirstNameCompositionUpdate}
            onCompositionEnd={this.handleFirstNameCompositionEnd}
          />
        </div>

        {this.isWithPhonetic && (
          <React.Fragment>
            <FormLabel
              valid={valid}
              label={object.data.phonetic.label}
              required={object.validations.required}
              showStatus={false}
            />
            <div className="cu-ui-full-name">
              <input
                { ...inputProps }
                { ...this.inputMap.lastNamePhonetic.input }
                data-testid="FullNameForm_lastNamePhoneticInput"
                placeholder={get(object, 'data.phonetic.last_name.placeholder', '')}
                onFocus={this.handleFocusInput(this.inputMap.lastNamePhonetic.input.onFocus)}
                onBlur={this.handleBlurInput(this.inputMap.lastNamePhonetic.input.onBlur)}
              />
              <input
                { ...inputProps }
                { ...this.inputMap.firstNamePhonetic.input }
                data-testid="FullNameForm_firstNamePhoneticInput"
                placeholder={get(object, 'data.phonetic.first_name.placeholder', '')}
                onFocus={this.handleFocusInput(this.inputMap.firstNamePhonetic.input.onFocus)}
                onBlur={this.handleBlurInput(this.inputMap.firstNamePhonetic.input.onBlur)}
              />
            </div>
          </React.Fragment>
        )}
        <FormErrorMessage
          error={error}
          touched={touched}
        />
      </div>
    );
  }

  get isWithPhonetic () {
    return get(this.props, 'object.data.enable_phonetic_input', false);
  }

  get inputMap () {
    return {
      firstName: this.props[this.props.nameMap.firstName],
      lastName: this.props[this.props.nameMap.lastName],
      firstNamePhonetic: this.props[this.props.nameMap.firstNamePhonetic],
      lastNamePhonetic: this.props[this.props.nameMap.lastNamePhonetic],
    };
  }

  get error () {
    const im = this.inputMap;

    if (this.isWithPhonetic) {
      return (
        im.firstName.meta.error
        || im.lastName.meta.error
        || im.firstNamePhonetic.meta.error
        || im.lastNamePhonetic.meta.error
      );
    } else {
      return (
        im.firstName.meta.error
        || im.lastName.meta.error
      );
    }
  }

  get touched () {
    const im = this.inputMap;

    if (this.isWithPhonetic) {
      return (
        im.firstName.meta.touched
        && im.lastName.meta.touched
        && im.firstNamePhonetic.meta.touched
        && im.lastNamePhonetic.meta.touched
      );
    } else {
      return (
        im.firstName.meta.touched
        && im.lastName.meta.touched
      );
    }
  }

  get valid () {
    const im = this.inputMap;

    if (this.isWithPhonetic) {
      return (
        im.firstName.meta.valid
        && im.lastName.meta.valid
        && im.firstNamePhonetic.meta.valid
        && im.lastNamePhonetic.meta.valid
      );
    } else {
      return (
        im.firstName.meta.valid
        && im.lastName.meta.valid
      );
    }
  }
}
